import { makeAutoObservable } from 'mobx';

class ReminderDirectoryState {
  store;
  history;
  match;

  reminders = [];

  constructor(store, history, match) {
    makeAutoObservable(this, {
      store: false,
      history: false
    });

    this.store = store;
    this.history = history;
    this.match = match;
  }

  async load() {
    await this.store.load();
    this.reminders = this.store.getReminders();
  }

  goToNew() {
    this.history.push('/reminders/new');
  }

  async removeReminder(reminder) {
    await this.store.destroy(reminder);
    await this.load();
  }
}

export default ReminderDirectoryState;
